import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

// This pipe is required to fix a bug that occurs in MS Edge with Angular 4.
// I understand the bug in Angular is resolved in Angular 5, so we can try 
// to remove this when the project runs under Angular 5.
// MT:3/22/2018

@Pipe({
  name: 'datex'
})
export class DatexPipe implements PipeTransform {

  transform(value: any, format: string = ""): string {
    // Try and parse the passed value.
    var momentDate = moment(value);

    // If moment didn't understand the value, return it unformatted.
    if (!momentDate.isValid()) return value;

    // Otherwise, return the date formatted as requested.
    return momentDate.format(format);
}

}



// WEBPACK FOOTER //
// ./src/app/pipes/datex.pipe.ts